import { createSelector } from '@reduxjs/toolkit';
import { selectPlacementType } from 'shared/selectors/jsonQuery';
import { EPlacementType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Первый этаж здания', value: EPlacementType.StreetRetail },
  { label: 'В торговом комплексе', value: EPlacementType.ShoppingMall },
];

export const selectPlacementTypeFilter = createSelector(selectPlacementType, value => ({
  label: 'Тип помещения',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
